import React, { useState } from "react";
import { GiReturnArrow } from "react-icons/gi";
import { useDispatch } from "react-redux";
import { refuseRejectAction } from "../../Actions/RejectAction/RejectAction";

const RefuseRejectModal = ({ visits, closeModal }) => {
  const [visit, setVisit] = useState([]);
  const dispatch = useDispatch();
  const handleReturnReject = (e) => {
    e.preventDefault();

    dispatch(refuseRejectAction(visit.id, visit.rejects.id));
    closeModal();
  };
  const handleSelectChange = (e) => {
    const selectedVisit = e.target.value;
    if (selectedVisit !== "-1") {
      const visitObject = JSON.parse(selectedVisit);
      setVisit(visitObject);
    } else {
      setVisit(-1);
    }
  };

  return (
    <div className="modal">
      <div className="modal-overlay">
        <div className="modal-container w-4/12 mt-2">
          <div className="modal-header items-center justify-between flex gap-3">
            <h3 onClick={closeModal} className="cursor-pointer">
              X
            </h3>
            <div>
              <select
                name=""
                onChange={handleSelectChange}
                className="input w-full"
                id=""
              >
                <option value="-1">Select Visit</option>
                {visits?.map((visit, index) => (
                  <option key={index} value={JSON.stringify(visit)}>
                    {visit.created_at.split("T")[0]}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div>
            <p className="text-center mt-2 font-bold">
              {" "}
              دڵنیایەی لە گەڕانەوی زانیاری ئەم نەخۆشە ؟{" "}
            </p>
          </div>
          <form action="">
            {visit == -1 ? (
              ""
            ) : (
              <button
                onClick={handleReturnReject}
                className="btn-info flex items-center gap-2"
              >
                Return <GiReturnArrow />
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default RefuseRejectModal;
